export var StorageStrategyErrors;
(function (StorageStrategyErrors) {
    StorageStrategyErrors["KEY_EXISTS"] = "Key already exists in database";
    StorageStrategyErrors["KEY_NOT_EXISTS"] = "Key does not exists in database";
    StorageStrategyErrors["STORAGE_EXISTS"] = "Storage already exists";
    StorageStrategyErrors["STORAGE_NOT_SUPPORTED"] = "Storage types not supported";
})(StorageStrategyErrors || (StorageStrategyErrors = {}));
